import { SwxTheme } from 'swx-atomic-component-lib'

const themeUtil = {
  primary: {
    bgColor: SwxTheme.palette.primary,
    textColor: SwxTheme.palette.white
  },
  'primary-alt': {
    bgColor: SwxTheme.palette['primary-alt'],
    textColor: SwxTheme.palette.white
  },
  yellow: {
    bgColor: SwxTheme.palette.yellow,
    textColor: SwxTheme.palette['secondary-dark']
  },
  white: {
    bgColor: SwxTheme.palette.white,
    textColor: SwxTheme.palette['secondary-dark']
  }
}

export default themeUtil
